import React from "react";
import { renderComponentBasedOnState } from "./MyContractsStates";
import { determineState } from "./DetermineState";
import { makeStyles } from "@mui/styles";
import {
  selectMyContractsState,
  setCurrentAction,
  setShouldFetchContracts,
} from "../../../../../../features/myContracts/myContractsSlice";
import { selectUserInfo } from "../../../../../../features/userInfo/userInfoSlice";
import { selectGlobalDataState } from "../../../../../../features/global/globalDataSlice";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Grid, Card, TextField } from "@mui/material";
import colors from "../../../../../colors";
import AddIcon from "@mui/icons-material/Add";
import Fab from "@mui/material/Fab";
import { sendGeneralRequest } from "../../../../../../features/generalRequest";
import MyContractsActionHandler from "./MyContractsActionHandler";
import { texts } from "../../../../../general/texts";

const MyContractsTest = (props) => {
  const useStyles = makeStyles({
    scrollBar: {
      "&::-webkit-scrollbar": {
        width: "10px",
        height: "50%",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#FFFFFF",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "linear-gradient(to bottom, #EF7A30, #F0A13D)",
        borderRadius: "10px",
        maxHeight: "50%",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "linear-gradient(to bottom, #EF7A30, #F0A13D)",
      },
      maxHeight: "500px",
      overflow: "auto",
      paddingLeft: "6%",
      marginTop: 1,
    },
    myContracts: {
      fontFamily: "GerberaBold",
      color: colors.darkBlue,
      textAlign: "left",
      fontSize: "1.65rem",
    },
    mainGrid: {
      justifyContent: props.utilityName === "" ? "center" : "left",
      "@media (max-width: 899px)": { justifyContent: "center" },
    },
    card: {
      width: props.utilityName === "P2P" ? "50%" : "65%",
      height: "650px",
      // height:props.utilityName === 'P2P' ? '55vh' : '70vh',
      borderRadius: "20px",
      boxShadow: "0 0 15px 5px #E5E7EA",
      "@media (max-width: 1440px )": {
        width:
          props.utilityName === ""
            ? "60%"
            : props.utilityName === "P2P"
            ? "70%"
            : "70%",
      },
      "@media (max-width: 1320px )": {
        width:
          props.utilityName === ""
            ? "60%"
            : props.utilityName === "P2P"
            ? "80%"
            : "100%",
      },
      "@media (max-width: 899px )": { width: "90%" },
    },
    cardBasicAccount: {
      width: props.utilityName === "P2P" ? "50%" : "65%",
      minHeight: "70vh",
      borderRadius: props.utilityName === "" ? "20px" : "20px",
      "@media (max-width: 1440px )": { width: "90%" },
      "@media (max-width: 1320px )": { width: "100%" },
      "@media (max-width: 899px )": { width: "90%" },
    },
    deleteButton: {
      background: colors.white,
      height: "4rem",
      color: colors.gray,
      borderRadius: "100%",
      "&:hover": { background: colors.lightGray },
    },
  });

  const classes = useStyles();
  const myContractsSliceState = useSelector(selectMyContractsState);
  const globalDataSliceState = useSelector(selectGlobalDataState);
  const userInfoSliceState = useSelector(selectUserInfo);
  const dispatch = useDispatch();
  const request = {
    token: globalDataSliceState.token,
    service: "",
  };
  const [searchResult, setSearchResult] = React.useState("");

  const filterContracts = () => {
    if (searchResult === "") {
      if (props.utilityName !== "") {
        return myContractsSliceState.contracts.filter((contract) => {
          if (props.utilityName === "UJESJELLES") {
            return contract.service.toLowerCase().substring(0, 2) === "uk";
          } else {
            return (
              contract.service.toLowerCase() === props.utilityName.toLowerCase()
            );
          }
        });
      } else {
        return myContractsSliceState.contracts;
      }
    } else {
      if (props.utilityName === "UJESJELLES") {
        return myContractsSliceState.contracts.filter((contract) => {
          return (
            (contract.contract
              .toLowerCase()
              .includes(searchResult.toLowerCase()) ||
              contract.description
                .toLowerCase()
                .includes(searchResult.toLowerCase()) ||
              contract.optional
                .toLowerCase()
                .includes(searchResult.toLowerCase())) &&
            contract.service.toLowerCase().substring(0, 2) === "uk"
          );
        });
      } else if (props.utilityName !== "") {
        return myContractsSliceState.contracts.filter((contract) => {
          return (
            (contract.contract
              .toLowerCase()
              .includes(searchResult.toLowerCase()) ||
              contract.description
                .toLowerCase()
                .includes(searchResult.toLowerCase()) ||
              contract.optional
                .toLowerCase()
                .includes(searchResult.toLowerCase())) &&
            props.utilityName.toLowerCase() === contract.service.toLowerCase()
          );
        });
      } else {
        return myContractsSliceState.contracts.filter((contract) => {
          return (
            contract.contract
              .toLowerCase()
              .includes(searchResult.toLowerCase()) ||
            contract.description
              .toLowerCase()
              .includes(searchResult.toLowerCase()) ||
            contract.optional.toLowerCase().includes(searchResult.toLowerCase())
          );
        });
      }
    }
  };

  const filteredContracts = React.useMemo(
    () => filterContracts(),
    [searchResult, myContractsSliceState.contracts]
  );

  React.useEffect(() => {
    if (myContractsSliceState.shouldFetchContracts) {
      dispatch(
        sendGeneralRequest({
          request: request,
          baseUrlKey: "services",
          endpoint: "ListContracts",
        })
      );
      dispatch(setShouldFetchContracts(false));
    }
  }, [myContractsSliceState.shouldFetchContracts]);

  return (
    <Grid container className={classes.mainGrid}>
      <Card className={classes.card} elevation={3}>
        <Grid
          item
          container
          md={12}
          xs={12}
          justifyContent={"flex-start"}
          p={"3%"}
          pl={"5%"}
          pt={5}
        >
          <Grid container item md={12} xs={12} pb={5}>
            <Grid container item md={10} xs={10}>
              <Typography className={classes.myContracts}>
                {texts["title-favorite"]}{" "}
              </Typography>
            </Grid>
            {userInfoSliceState.accountType === 3 ||
            props.utilityName === "" ||
            props.utilityName === "TAKSAT_SHKODER" ||
            props.utilityName === "TAKSAT_DURRES" ||
            props.utilityName === "Siguracione" ? (
              <Grid></Grid>
            ) : (
              <Grid
                container
                item
                md={2}
                xs={2}
                justifyContent={"center"}
                alignContent={"center"}
              >
                <Fab
                  onClick={() => dispatch(setCurrentAction("addContract"))}
                  sx={{
                    background: colors.gradientOrange,
                    color: colors.white,
                  }}
                >
                  <AddIcon fontSize="large" />
                </Fab>
              </Grid>
            )}
          </Grid>
          <Grid container item md={12} xs={12} pr={"45px"} pb={"30px"}>
            <TextField
              fullWidth
              onChange={(e) => setSearchResult(e.target.value)}
              size={"small"}
              color={"warning"}
              variant={"outlined"}
              label={"Kërko"}
              sx={{
                background: colors.cyan,
                borderRadius: "15px",
                [`& fieldset`]: {
                  borderColor: colors.cyan,
                  borderRadius: "15px",
                },
              }}
            ></TextField>
          </Grid>
          <Grid container item md={12} xs={12} spacing={3} pb={"2%"}>
            {renderComponentBasedOnState(
              determineState({
                userInfoSliceState: userInfoSliceState,
                contracts: filteredContracts,
                location: props.currentLocation,
                utilityName: props.utilityName,
              }),
              { filteredContracts }
            )}
          </Grid>
        </Grid>
      </Card>
      <MyContractsActionHandler utilityName={props.utilityName} /> 
    </Grid>
  );
};

export default MyContractsTest;
